"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSubjectGroupNotAllowedError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Error when adding subject group to non subject tag
 */
class TagSubjectGroupNotAllowedError extends client_library_1.ExtendableError {
    constructor() {
        super(`Non subject tag cannot have subject group`);
    }
}
exports.TagSubjectGroupNotAllowedError = TagSubjectGroupNotAllowedError;
//# sourceMappingURL=TagSubjectGroupNotAllowedError.js.map